import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SseForm } from './sse-index.interface';
import { environment } from '../../../environments/environment';
import { SseList } from './sse-checklist.interface';

@Injectable({
    providedIn: 'root'
})

  export class SseFormService {
      private apiUrl = `${environment.apiConfig.uri}/sse`;
      private apiUrlList = `${environment.apiConfig.uri}/sselist`;
      constructor(private http: HttpClient) {
      }

      createForm(formData: SseForm): Observable<any> {
        return this.http.post(this.apiUrl, formData)
      }

      updateSection2(formId: string, section2Data: SseForm['section2']): Observable<any> {
        const url = `${this.apiUrl}/${formId}/section2`;
        return this.http.put(url, { section2: section2Data });
      }
    
      updateSection3(formId: string, section3Data: SseForm['section3']): Observable<any> {
        const url = `${this.apiUrl}/${formId}/section3`;
        return this.http.put(url, { section3: section3Data });
      }
    
      getForm(formId: string): Observable<any> {
        const url = `${this.apiUrl}/${formId}`;
        return this.http.get(url)
      }

      findAllSse(): Observable<any> {
        return this.http.get<any>(this.apiUrl);
      }

      findAllSseList(): Observable<any> {
        return this.http.get<any>(this.apiUrlList);
      }

      getSseListById(sseListId: string): Observable<any> {
        const url = `${this.apiUrlList}/${sseListId}`;
        return this.http.get(url)
      }

      updateSseList(sseListId: string, updates: Partial<SseList>): Observable<any> {
        const url = `${this.apiUrlList}/${sseListId}`;
        return this.http.put(url, updates);
      }
  }